// import { useState } from 'react'
// import * as Yup from 'yup'
// import clsx from 'clsx'
// import { Link } from 'react-router-dom'
// import { useFormik } from 'formik'
// import { requestPassword } from '../core/_requests'

// const initialValues = {
//   email: '',
// }

// const forgotPasswordSchema = Yup.object().shape({
//   email: Yup.string()
//     .email('Wrong email format')
//     .min(3, 'Minimum 3 symbols')
//     .max(50, 'Maximum 50 symbols')
//     .required('Email is required'),
// })

// export function ForgotPassword() {
//   const [loading, setLoading] = useState(false)
//   const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
//   const formik = useFormik({
//     initialValues,
//     validationSchema: forgotPasswordSchema,
//     onSubmit: (values, { setStatus, setSubmitting }) => {
//       setLoading(true)
//       setHasErrors(undefined)
//       setTimeout(() => {
//         requestPassword(values.email)
//           .then(({ data: { result } }) => {
//             setHasErrors(false)
//             setLoading(false)
//           })
//           .catch(() => {
//             setHasErrors(true)
//             setLoading(false)
//             setSubmitting(false)
//             setStatus('The login detail is incorrect')
//           })
//       }, 1000)
//     },
//   })

//   return (
//     <form
//       className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
//       noValidate
//       id='kt_login_password_reset_form'
//       onSubmit={formik.handleSubmit}
//     >
//       <div className='text-center mb-10'>
//         {/* begin::Title */}
//         <h1 className='fw-bolder mb-3' style={{ color: "white" }}>Forgot Password ?</h1>
//         {/* end::Title */}

//         {/* begin::Link */}
//         <div className='text-gray-500 fw-semibold fs-6'>
//           Enter your email to reset your password.
//         </div>
//         {/* end::Link */}
//       </div>

//       {/* begin::Title */}
//       {hasErrors === true && (
//         <div className='mb-lg-15 alert alert-danger'>
//           <div className='alert-text font-weight-bold'>
//             Sorry, looks like there are some errors detected, please try again.
//           </div>
//         </div>
//       )}

//       {hasErrors === false && (
//         <div className='mb-10 bg-light-info p-8 rounded'>
//           <div className='text-info'>Sent password reset. Please check your email</div>
//         </div>
//       )}
//       {/* end::Title */}

//       {/* begin::Form group */}
//       <div className='fv-row mb-8'>
//         <label className='form-label fw-bolder fs-6' style={{ color: "white" }}>Email</label>
//         <input
//           type='email'
//           placeholder=''
//           autoComplete='off'
//           {...formik.getFieldProps('email')}
//           className={clsx(
//             'form-control bg-white',
//             { 'is-invalid': formik.touched.email && formik.errors.email },
//             {
//               'is-valid': formik.touched.email && !formik.errors.email,
//             }
//           )}
//         />
//         {formik.touched.email && formik.errors.email && (
//           <div className='fv-plugins-message-container'>
//             <div className='fv-help-block'>
//               <span role='alert'>{formik.errors.email}</span>
//             </div>
//           </div>
//         )}
//       </div>
//       {/* end::Form group */}

//       {/* begin::Form group */}
//       <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
//         <button type='submit' id='kt_password_reset_submit' className='btn btn-primary me-4'>
//           <span className='indicator-label'>Submit</span>
//           {loading && (
//             <span className='indicator-progress'>
//               Please wait...
//               <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
//             </span>
//           )}
//         </button>
//         <Link to='/auth/login'>
//           <button
//             type='button'
//             id='kt_login_password_reset_form_cancel_button'
//             className='btn btn-light'
//             disabled={formik.isSubmitting || !formik.isValid}
//           >
//             Cancel
//           </button>
//         </Link>{' '}
//       </div>
//       {/* end::Form group */}
//     </form>
//   )
// }




import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
// import { successToast, errorToast } from '../../../_metronic/helpers/components/Toaster'
import { successToast, errorToast } from '../../../../_metronic/helpers/components/Toaster'
import axios from 'axios'

const phoneSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .matches(/^[6-9]\d{9}$/, 'Enter a valid Indian mobile number starting with 6, 7, 8, or 9'),
})

const otpSchema = Yup.object().shape({
  otp1: Yup.string().required('OTP is required').matches(/^[0-9]$/, 'Must be a digit'),
  otp2: Yup.string().required('OTP is required').matches(/^[0-9]$/, 'Must be a digit'),
  otp3: Yup.string().required('OTP is required').matches(/^[0-9]$/, 'Must be a digit'),
  otp4: Yup.string().required('OTP is required').matches(/^[0-9]$/, 'Must be a digit'),
})

const passwordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Password must contain uppercase, lowercase, number and special character')
    .required('New password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm password is required'),
})

export function ForgotPassword() {
  const [step, setStep] = useState(1) // 1: phone, 2: otp, 3: password
  const [loading, setLoading] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [countryCode] = useState('91')
  const [isResending, setIsResending] = useState(false)

  const navigate = useNavigate()
  // OTP input refs
  const inputRef1 = useRef<HTMLInputElement>(null)
  const inputRef2 = useRef<HTMLInputElement>(null)
  const inputRef3 = useRef<HTMLInputElement>(null)
  const inputRef4 = useRef<HTMLInputElement>(null)

  const sendOTP = async (phone: string) => {
    setLoading(true)
    try {
      const url = `https://pfc-backend-api.asmglobal.co.in/v1/api/sendOtp?mobile=${phone}&countryCode=${countryCode}&from=forgotPassword`
      const response = await axios.get(url, {
        headers: {
          'accept': 'application/json',
          'app-id': '3',
          'client-id': '101212',
        }
      })

      if (response.data?.errors && response.data.errors.length > 0) {
        const errorMessage = response.data.errors[0].message || 'Failed to send OTP. Please try again.'
        errorToast(errorMessage)
        return false
      }

      if (response.status === 200) {
        setPhoneNumber(phone)
        setStep(2)
        successToast('OTP sent successfully')
        setTimeout(() => {
          if (inputRef1.current) {
            inputRef1.current.focus()
          }
        }, 100)
        return true
      }
    } catch (error: any) {
      let errorMessage = 'Failed to send OTP. Please try again.'
      if (error.response?.data?.errors && error.response.data.errors.length > 0) {
        errorMessage = error.response.data.errors[0].message
      }
      errorToast(errorMessage)
      return false
    } finally {
      setLoading(false)
      setIsResending(false)
    }
  }

  const verifyOTP = async (otp: string) => {
    setLoading(true)
    try {
      const response = await axios.post(
        'https://pfc-backend-api.asmglobal.co.in/v1/api/validateOtp',
        {
          mobile: phoneNumber,
          otp: otp
        },
        {
          headers: {
            'accept': 'application/json',
            'Accept-Encoding': 'gzip',
            'app-id': '3',
            'client-id': '101212',
            'Content-Type': 'application/json',
          }
        }
      )

      if (response.status === 200) {
        setStep(3)
        successToast('OTP verified successfully')
        return true
      }
    } catch (error) {
      errorToast('Invalid OTP. Please try again.')
      return false
    } finally {
      setLoading(false)
    }
  }

  const resetPassword = async (newPassword: string) => {
    setLoading(true)
    try {
      const response = await axios.put(
        'https://pfc-backend-api.asmglobal.co.in/v1/api/user/resetPassword',
        {
          newPassword: newPassword,
          userName: phoneNumber
        },
        {
          headers: {
            'accept': 'application/json',
            'Accept-Encoding': 'gzip',
            'app-id': '3',
            'client-id': '101212',
            'Content-Type': 'application/json',
          }
        }
      )

      if (response.status === 200) {
        successToast('Password reset successfully')
        return true
      }
    } catch (error) {
      errorToast('Failed to reset password. Please try again.')
      return false
    } finally {
      setLoading(false)
    }
  }

  const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextRef: React.RefObject<HTMLInputElement> | null) => {
    const value = e.target.value
    if (!/^\d*$/.test(value)) {
      e.preventDefault()
      return
    }
    if (value.length === 1 && nextRef && nextRef.current) {
      nextRef.current.focus()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, prevRef: React.RefObject<HTMLInputElement> | null) => {
    if (e.key === 'Backspace' && prevRef && (e.target as HTMLInputElement).value === '') {
      prevRef.current?.focus()
    }
  }

  const phoneFormik = useFormik({
    initialValues: { phoneNumber: '' },
    validationSchema: phoneSchema,
    onSubmit: async (values) => {
      await sendOTP(values.phoneNumber)
    },
  })

  const otpFormik = useFormik({
    initialValues: { otp1: '', otp2: '', otp3: '', otp4: '' },
    validationSchema: otpSchema,
    onSubmit: async (values) => {
      const otp = `${values.otp1}${values.otp2}${values.otp3}${values.otp4}`
      await verifyOTP(otp)
    },
  })

  const passwordFormik = useFormik({
    initialValues: { newPassword: '', confirmPassword: '' },
    validationSchema: passwordSchema,
    onSubmit: async (values) => {
      const success = await resetPassword(values.newPassword)
      if (success) {
        // Reset all forms and go back to step 1
        // setStep(1)
        phoneFormik.resetForm()
        otpFormik.resetForm()
        passwordFormik.resetForm()
        setPhoneNumber('')
        navigate('/auth')
      }
    },
  })

  const resendOTP = async () => {
    setIsResending(true)
    await sendOTP(phoneNumber)
  }

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={
        step === 1 ? phoneFormik.handleSubmit :
          step === 2 ? otpFormik.handleSubmit :
            passwordFormik.handleSubmit
      }
    >
      <div className='text-center mb-10'>
        <h1 className='fw-bolder mb-3' style={{ color: "white" }}>
          {step === 1 ? 'Forgot Password ?' :
            step === 2 ? 'Verify OTP' :
              'Reset Password'}
        </h1>
        <div className='text-gray-500 fw-semibold fs-6'>
          {step === 1 ? 'Enter your mobile number to reset your password.' :
            step === 2 ? `Enter the OTP sent to +${countryCode} ${phoneNumber.substring(0, 3)}*****${phoneNumber.substring(phoneNumber.length - 2)}` :
              'Enter your new password'}
        </div>
      </div>

      {/* Step 1: Phone Number */}
      {step === 1 && (
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder fs-6' style={{ color: "white" }}>Mobile Number</label>
          <div className='d-flex'>
            <span className='input-group-text'>+{countryCode}</span>
            <input
              type='tel'
              placeholder='Enter your 10-digit mobile number'
              autoComplete='off'
              maxLength={10}
              {...phoneFormik.getFieldProps('phoneNumber')}
              className={clsx(
                'form-control bg-white',
                { 'is-invalid': phoneFormik.touched.phoneNumber && phoneFormik.errors.phoneNumber },
                { 'is-valid': phoneFormik.touched.phoneNumber && !phoneFormik.errors.phoneNumber }
              )}
              onInput={(e) => {
                const target = e.target as HTMLInputElement;
                target.value = target.value.replace(/[^0-9]/g, '');
              }}
            />
          </div>
          {phoneFormik.touched.phoneNumber && phoneFormik.errors.phoneNumber && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{phoneFormik.errors.phoneNumber}</span>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Step 2: OTP Verification */}
      {step === 2 && (
        <div className='mb-8'>
          <div className='d-flex justify-content-center gap-3 mb-7'>
            <input
              ref={inputRef1}
              maxLength={1}
              className='form-control form-control-lg text-center fw-bold fs-2'
              style={{ width: '60px', height: '60px', backgroundColor: 'white' }}
              {...otpFormik.getFieldProps('otp1')}
              onChange={(e) => {
                otpFormik.handleChange(e);
                handleOtpInput(e, inputRef2);
              }}
              onKeyDown={(e) => handleKeyDown(e, null)}
            />
            <input
              ref={inputRef2}
              maxLength={1}
              className='form-control form-control-lg text-center fw-bold fs-2'
              style={{ width: '60px', height: '60px', backgroundColor: 'white' }}
              {...otpFormik.getFieldProps('otp2')}
              onChange={(e) => {
                otpFormik.handleChange(e);
                handleOtpInput(e, inputRef3);
              }}
              onKeyDown={(e) => handleKeyDown(e, inputRef1)}
            />
            <input
              ref={inputRef3}
              maxLength={1}
              className='form-control form-control-lg text-center fw-bold fs-2'
              style={{ width: '60px', height: '60px', backgroundColor: 'white' }}
              {...otpFormik.getFieldProps('otp3')}
              onChange={(e) => {
                otpFormik.handleChange(e);
                handleOtpInput(e, inputRef4);
              }}
              onKeyDown={(e) => handleKeyDown(e, inputRef2)}
            />
            <input
              ref={inputRef4}
              maxLength={1}
              className='form-control form-control-lg text-center fw-bold fs-2'
              style={{ width: '60px', height: '60px', backgroundColor: 'white' }}
              {...otpFormik.getFieldProps('otp4')}
              onChange={(e) => {
                otpFormik.handleChange(e);
              }}
              onKeyDown={(e) => handleKeyDown(e, inputRef3)}
            />
          </div>
          <div className='text-center mb-5'>
            <span className='text-gray-500 me-2'>Didn't receive OTP Code?</span>
            <a
              href='#'
              className='text-white fw-bold'
              onClick={(e) => {
                e.preventDefault();
                if (!isResending) {
                  resendOTP();
                }
              }}
            >
              {isResending ? 'Sending...' : 'Resend Code'}
            </a>
          </div>
        </div>
      )}

      {/* Step 3: New Password */}
      {step === 3 && (
        <>
          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder fs-6' style={{ color: "white" }}>New Password</label>
            <input
              type='password'
              placeholder='Enter new password'
              autoComplete='new-password'
              {...passwordFormik.getFieldProps('newPassword')}
              className={clsx(
                'form-control bg-white',
                { 'is-invalid': passwordFormik.touched.newPassword && passwordFormik.errors.newPassword },
                { 'is-valid': passwordFormik.touched.newPassword && !passwordFormik.errors.newPassword }
              )}
            />
            {passwordFormik.touched.newPassword && passwordFormik.errors.newPassword && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{passwordFormik.errors.newPassword}</span>
                </div>
              </div>
            )}
          </div>
          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder fs-6' style={{ color: "white" }}>Confirm Password</label>
            <input
              type='password'
              placeholder='Confirm new password'
              autoComplete='new-password'
              {...passwordFormik.getFieldProps('confirmPassword')}
              className={clsx(
                'form-control bg-white',
                { 'is-invalid': passwordFormik.touched.confirmPassword && passwordFormik.errors.confirmPassword },
                { 'is-valid': passwordFormik.touched.confirmPassword && !passwordFormik.errors.confirmPassword }
              )}
            />
            {passwordFormik.touched.confirmPassword && passwordFormik.errors.confirmPassword && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{passwordFormik.errors.confirmPassword}</span>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {/* Form Actions */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' className='btn btn-primary me-4'>
          <span className='indicator-label'>
            {step === 1 ? 'Send OTP' :
              step === 2 ? 'Verify OTP' :
                'Reset Password'}
          </span>
          {loading && (
            <span className='indicator-progress'>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            className='btn btn-light'
            disabled={loading}
          >
            Cancel
          </button>
        </Link>
      </div>
    </form>
  )
}